module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"languages":["en","es"],"defaultLanguage":"en","siteUrl":"http://localhost:8000","localeJsonSourceName":"locales","i18nextOptions":{"interpolation":{"escapeValue":false},"detection":{"order":["cookie","header","querystring","localStorage","navigator"],"caches":["cookie"]}}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
